import React from 'react';
import { Field } from 'formik';
import { getIntl } from '../../../../utils/intl';
import useNotes from '../../../../hooks/api/useNotes';
import useOrganization from '../../../../hooks/api/useOrganization';
import { FormikInputs } from '../../../v2BaseComponents/Inputs';
import { SplitFormRow } from '../../../v2BaseComponents/Form';

const intl = getIntl('VisitAddNotePicker', {
    addNote: 'Add Note',
    untitled: 'Untitled note',
});

/**
 * "Add Note" select for visit creation — lists the organization's resource notes by
 * title; the chosen note is copied onto the created visit(s) server-side.
 */
const AddNotePickerInner: React.FC<{ isDisabled?: boolean; organizationId: string }> = ({
    isDisabled,
    organizationId,
}) => {
    const { notes, isFetchingNotes } = useNotes({
        noteQueryArgs: { entityType: 'organization', organizationId },
    });

    if (!isFetchingNotes && !notes.notes.length) return null;

    return (
        <SplitFormRow>
            <Field
                component={FormikInputs.Select}
                name="sourceNoteId"
                title={intl('addNote')}
                isDisabled={isDisabled || isFetchingNotes}
                selectOptions={notes.notes.map((note) => ({
                    label: note.title || intl('untitled'),
                    value: note.noteId,
                    testID: note.title || note.noteId,
                }))}
            />
        </SplitFormRow>
    );
};

/** Renders nothing when the signed-in user has no organization (family app safety). */
const AddNotePicker: React.FC<{ isDisabled?: boolean }> = (props) => {
    const { myOrganization } = useOrganization({});
    const organizationId = myOrganization?.organization?.organizationId;
    if (!organizationId) return null;
    return <AddNotePickerInner {...props} organizationId={organizationId} />;
};

export default React.memo(AddNotePicker);
